import styled from 'styled-components';

import * as colors from 'constants/styles/colors';


export const HeaderWrapper = styled.div`
  background-color: ${colors.colorTurquoiseGreen};
  width: 100vw;
  max-height: 3.75rem;
  padding: 1.5rem 0;
  text-align: center;
`;
